var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable unicorn/prefer-string-slice */
import React, { useState, useMemo, useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import { ToggleTextStyle } from './markdown-styles';
var _htmlPlugins = [rehypeRaw, rehypeSanitize];
var Markdown = function (_a) {
    var inputText = _a.inputText, collapseLimit = _a.collapseLimit, collapseText = _a.collapseText, expandText = _a.expandText, escapeHtml = _a.escapeHtml, restProps = __rest(_a, ["inputText", "collapseLimit", "collapseText", "expandText", "escapeHtml"]);
    var _b = useState(true), isCollapsed = _b[0], setIsCollapsed = _b[1];
    var toggledText = useMemo(function () {
        if (collapseLimit && isCollapsed && inputText.length > collapseLimit) {
            return inputText.substring(0, collapseLimit);
        }
        return inputText;
    }, [isCollapsed, inputText, collapseLimit]);
    var handleClick = useCallback(function () {
        setIsCollapsed(!isCollapsed);
    }, [isCollapsed]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ReactMarkdown, __assign({ rehypePlugins: escapeHtml ? _htmlPlugins : undefined }, restProps), toggledText),
        collapseLimit && (React.createElement(ToggleTextStyle, { onClick: handleClick }, isCollapsed ? expandText : collapseText))));
};
export default Markdown;
